import axiosInstance from "../../../config/axios";

export const getAccountReceivablesRetailerList = async (params: any) => {
    const response = await axiosInstance.get('/retailer/accountReceivables', { params });
    return response.data;
}

// Live outstanding balance for the logged-in retailer's store (customer is
// resolved from the token). Same response shape as the sales endpoint.
export const getRetailerCustomerBalance = async () => {
    const response = await axiosInstance.get('/retailer/customerBalance');
    return response.data;
}